import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroupDirective, FormArray, NgForm, Validators, } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ErrorStateMatcher } from '@angular/material/core';
import * as moment from 'moment';
import differenceBy from 'lodash/differenceBy';
import { ClientService } from '../../services/client.service';
import { CourseService } from '../../services/course.service';
import { StaffService } from '../../services/staff/staff.service';
import { JobService } from '../../services/jobs/job.service';
import { Router, ActivatedRoute } from '@angular/router';
import { JobDatesComponent } from '../job-dates/job-dates.component';
import * as _ from 'lodash';
import { TrainingJobDatesComponent } from '../training-job-dates/training-job-dates.component';
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-add-job-modal',
  templateUrl: './add-job-modal.component.html',
  styleUrls: ['./add-job-modal.component.scss'],
})


export class AddJobModalComponent implements OnInit {
  isValidation = true
  placeholder = "Starting date"
  clients;
  clientsCopy = [];
  courses;
  instructors;
  IQAinstructors;
  selectedIQA = [];
  instlist;
  jobs;
  addJobForm;
  courseDates = [];
  startingDate;
  temp;
  selectedInstructors = [];
  selectedClients = [];
  selectedInstructorsForDb = [];
  jobDates: FormArray;
  totalDays = [];
  newTitle;
  duration;
  isDisabled: Boolean = false;
  finalCourseDates = [];
  matcher = new MyErrorStateMatcher();
  singleJobDate = [];
  loading: Boolean = false;
  selectedClient = {
    name: "Default",
    _id: ""
  };
  selectedLocation = {
    name: "Default",
    _id: ""
  };
  selectedCourse: any;
  color: any;
  rgba: any;
  always: any;
  data;
  jobFromScheduler: boolean = false;
  typeOfView = 'isList';
  displayPlanner: boolean = false
  plannerData
  isNotApplicable: boolean = false
  // minDate: any;
  @ViewChild(TrainingJobDatesComponent, { static: false }) jobDateComp: TrainingJobDatesComponent;
  error: any;
  totalExams: any;
  selectedInstructor = []
  date: any;
  dumyDate: any;
  endDate: any;
  isSubmit: boolean;
  trainersList = [];
  iqaList = [];
  userIsIQA
  staffDashBoard
  quizSchedule: boolean = false;
  quizStartDate: any;
  quizEndDate: any;
  quizStartTime: any;
  quizEndTime: any;
  constructor(public _snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, public _clientService: ClientService, public _courseService: CourseService, public _staffService: StaffService, public _jobService: JobService, private router: Router,
    public formBuilder: FormBuilder, private cd: ChangeDetectorRef) {

    this.activatedRoute.queryParams.subscribe(() => {
      if (this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
        console.log("what is in state data", this.router.getCurrentNavigation().extras.state);

        if (this.router.getCurrentNavigation().extras.state.job) {
          this.data = this.router.getCurrentNavigation().extras.state.job;
          console.log("What is the data", this.data);

          this.jobFromScheduler = true;
        }
        else if (this.router.getCurrentNavigation().extras.state.view) {
          this.typeOfView = this.router.getCurrentNavigation().extras.state.view
        }
        else if (this.router.getCurrentNavigation().extras.state.instructor) {
          console.log("hello here is the instructor data .....", this.router.getCurrentNavigation().extras.state.instructor)

          this.staffDashBoard = this.router.getCurrentNavigation().extras.state.instructor
          if (this.staffDashBoard && this.staffDashBoard.userId && this.staffDashBoard.userId.userRole && this.staffDashBoard.userId.userRole.includes('IQA') && this.staffDashBoard.userId.userRole.length == 1) {
            this.userIsIQA = true
          }
          // this.dropDownDisable()
        }
        else if (this.router.getCurrentNavigation().extras.state.data) {
          this.displayPlanner = true
          this.plannerData = this.router.getCurrentNavigation().extras.state.data
        }
      }
    });
  }
  ngOnInit() {
    console.log("ON INIT", this.data);
    this.createForm();
    this.finalCourseDates = [];
    // this.createForm();
    this.getClients();
    this.getCourses();
    this.getInstructors();

  }
  createForm() {
    if (this.jobFromScheduler) {
      this.addJobForm = this.formBuilder.group({
        title: new FormControl(this.data.title),
        // jobColor: new FormControl('', Validators.required),
        // client: new FormControl(''),
        instructors: new FormControl(''),
        IQAinstructors: new FormControl(''),

        // location: new FormControl(''),
        clients: this.formBuilder.array([this.multipleClients()]),
        course: new FormControl('', Validators.required),
        startingDate: new FormControl(this.data.start, Validators.required),
        scheduleDates: new FormControl(this.data.scheduleDates, Validators.required)
      });
      this.startingDate = this.data.start;
    } else if (this.displayPlanner) {
      console.log("call this for planner or not", this.plannerData);
      // let newDate = new Date(this.plannerData.date)
      // console.log("valid date or not", newDate);
      this.addJobForm = this.formBuilder.group({
        title: new FormControl('', Validators.required),
        // jobColor: new FormControl('', Validators.required),
        // client: new FormControl(''),
        instructors: new FormControl(''),
        IQAinstructors: new FormControl(''),

        // location: new FormControl(''),

        clients: this.formBuilder.array([this.multipleClients()]),
        course: new FormControl('', Validators.required),
        startingDate: new FormControl(new Date(this.plannerData.date), Validators.required),
        scheduleDates: new FormControl(false, Validators.required)
      });
      // this.selectedInstructors.push(this.plannerData.selectedUser)
      console.log("hello here is the data ....", this.selectedInstructors)

      if (this.plannerData && this.plannerData.role && this.plannerData.role.includes('IQA')) {
        this.userIsIQA = true
      }

      this.dumyDate = this.plannerData.date;
      this.date = this.plannerData.date;
      this.startingDate = this.plannerData.date;
    }
    else {

      this.addJobForm = this.formBuilder.group({
        title: new FormControl('', Validators.required),
        // jobColor: new FormControl('', Validators.required),
        clients: this.formBuilder.array([this.multipleClients()]),
        // client: new FormControl(''),
        instructors: new FormControl(''),
        IQAinstructors: new FormControl(''),

        // location: new FormControl(''),
        course: new FormControl('', Validators.required),
        startingDate: new FormControl('', Validators.required),
        scheduleDates: new FormControl(false, Validators.required),
      });

      console.log("this is for first time", this.addJobForm);
    }
  }

  multipleClients() {
    return this.formBuilder.group({
      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    })
  }


  get multipleClientsGroup() { return <FormArray>this.addJobForm.get('clients') }



  AddMultipleClients() {
    const control = <FormArray>this.addJobForm.controls.clients
    control.push(this.formBuilder.group({
      client: new FormControl('', Validators.required),
      location: new FormControl('', Validators.required),
    }))

  }

  deleteClient(data, i) {
    console.log("what is in client", data);
    console.log("index value============", i);
    const control = <FormArray>this.addJobForm.controls.clients
    control.removeAt(i)
    let clientId = data.value.client._id
    let locationId = data.value.location
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })


    console.log("main index value", index);

    if (index > -1) {

      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == locationId })
      // console.log("whatt is the index 1 value", index1);
      delete this.clients[index].locations[index1]['added']
      // console.log("remaining client value", this.clients[index].locations[index1]);
      // console.log("value of selected client", this.selectedClient);

    }
  }


  clearForm() {
    console.log("clear check boxes")
    this.jobDateComp.checkEnable = true;
    this.jobDateComp.clearCheckBoxes();
    this.addJobForm.reset();
    this.selectedCourse.duration = null
    console.log("form value---->", this.addJobForm)
    this.ngOnInit();
  }

  onChangeQStart(value) {
    this.quizStartDate = value;
    this.addJobForm.patchValue({ quizStartDate: this.quizStartDate })
    console.log("event call sucessfully", this.addJobForm.value)
  }

  onChangeQEnd(value) {
    this.quizEndDate = value;
    this.addJobForm.patchValue({ quizEndDate: this.quizEndDate })
    console.log("event call sucessfully", this.addJobForm.value)
  }

  onChange(value) {
    this.date = value;
    this.dumyDate = value
    this.jobDateComp.enableCheckBoxes();
    this.duration = this.selectedCourse.duration;
    this.startingDate = value;
    this.temp = moment(new Date(value));
    this.addJobForm.patchValue({ startingDate: this.date })
    console.log("event call sucessfully", this.addJobForm.value)
    // this.dateisValid1 = true;
    // this.isSubmit1 = false
  }

  onChangeEndDate(value) {
    this.endDate = value;
    this.addJobForm.patchValue({ endingDate: this.endDate })
    console.log("event call sucessfully", this.addJobForm.value)
    // this.dateisValid2 = true;
    // this.isSubmit2 = false
  }


  clientChanged(data, singleItem) {

    this.selectedClient = data.value;
    console.log("====================", singleItem, this.selectedClient);
    // console.log("form group value========", this.addJobForm);

    this.cd.detectChanges()
  }

  instructorChanged(data) {
    console.log("when user is selected", data);
    this.selectedInstructors = data.value;
    this.dropDownDisable()
  }
  IQAChange(data) {
    console.log("whene user selected", data);
    this.selectedIQA = data.value;
    this.dropDownDisable()
  }

  dropDownDisable() {
    const differences1 = differenceBy(this.trainersList, this.selectedIQA, '_id')
    if (differences1 && differences1.length) {
      this.trainersList.map(item => {
        if (differences1.includes(item))
          item.isSelected = false
        else
          item.isSelected = true
      })
    }
    const differences2 = differenceBy(this.iqaList, this.selectedInstructors, '_id')
    if (differences2 && differences2.length) {
      this.iqaList.map(item => {
        if (differences2.includes(item))
          item.isSelected = false
        else
          item.isSelected = true
      })
    }
    console.log("here is the trainer list and iqa list...11", differences1, differences2)
    // _.each(this.trainersList, (ins, i) => {
    //   const iqaIndex = _.findIndex(this.selectedIQA, (d) => { return ins._id == d._id; })
    //   console.log("hello here is option index =====>", i)
    //   if (iqaIndex > -1) {
    //     this.trainersList[i].isSelected = true
    //   }
    //   else {
    //     (this.trainersList[i].isSelected) ? this.trainersList[i].isSelected = false : this.trainersList[i].isSelected = false
    //   }
    // })
    // _.each(this.iqaList, (ins, i) => {
    //   const trainerIndex = _.findIndex(this.selectedInstructors, (d) => { return ins._id == d._id; })
    //   if (trainerIndex > -1) {
    //     this.iqaList[i].isSelected = true
    //   }
    //   else {
    //     (this.iqaList[i].isSelected) ? this.iqaList[i].isSelected = false : this.iqaList[i].isSelected = false
    //   }
    // })
  }

  checkApplicable(event) {
    console.log("event of applicable", event);
    console.log("value of cvheckbox", this.isNotApplicable);

    if (this.isNotApplicable) {
      console.log("this is for end date add");

      // this.addJobForm.addControl('endingDate', '');
      this.addJobForm.addControl('endingDate', new FormControl('', Validators.required));
      // this.addJobForm.removeControl('singleJobDate')
      // this.addJobForm.removeControl('totalDays')

    } else {
      console.log("this is end date not add");
      // this.addJobForm.addControl('singleJobDate', new FormControl([], Validators.required))
      // this.addJobForm.addControl('totalDays', new FormControl([], Validators.required))
      this.addJobForm.removeControl('endingDate');

    }

  }

  courseChanged(data) {
    if (this.router.url.includes('/scheduler')) {
      this.jobDateComp.enableCheckBoxes();
    }
    this.selectedCourse = data.value;
    if (this.selectedCourse.isQuizRelease) {
      this.addJobForm.addControl('quizStartTime', new FormControl(''));
      this.addJobForm.addControl('quizEndTime', new FormControl(''));
      this.addJobForm.addControl('quizStartDate', new FormControl(''));
      this.addJobForm.addControl('quizEndDate', new FormControl(''));
      this.quizSchedule = this.selectedCourse.isQuizRelease;
    } else {
      this.addJobForm.removeControl('quizStartTime');
      this.addJobForm.removeControl('quizEndTime');
      this.addJobForm.removeControl('quizStartDate');
      this.addJobForm.removeControl('quizEndDate');
      this.quizSchedule = false;
    }
    console.log(this.selectedCourse);
    this.duration = this.selectedCourse.duration;
    this.totalExams = this.selectedCourse.exams
  }

  // Event from app-job

  daySelection(obj) {
    console.log("-----DAY SELECTION EVENT-----", obj)
    console.log("OBJ", obj)
    this.singleJobDate = obj.singleJobDates;
    console.log("here find ", this.singleJobDate)

    var arrayLength = this.singleJobDate.length;
    for (var i = 0; i < arrayLength; i++) {
      console.log('here is final out put ---->', this.singleJobDate[i]);
      //Do something
      let date = new Date(this.singleJobDate[i].date)
      this.singleJobDate[i].date = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
    }



    this.totalDays = obj.totalDays;
    if (this.totalDays.length > 0) {
      this.error = ""
    }
  }

  searchDays($event) {
    this.jobDateComp.enableCheckBoxes();
    this.duration = this.selectedCourse.duration;
    this.startingDate = $event.value;
    this.temp = moment($event.value);
  }


  datesForJobChange(index) {
    this.finalCourseDates[index] = this.addJobForm.controls.singleJobDate.value
  }

  addJob() {

    // this.loading = true;

    this.isDisabled = true;

    // this.router.navigate(['/jobs' + '5f48ed48878ce754796948fd']);
    if (this.addJobForm.valid) {
      if (this.addJobForm.controls['title'].value) {
        this.newTitle = this.addJobForm.controls['title'].value
      } else if (this.selectedClient && this.selectedCourse) {
        this.newTitle = this.selectedClient.name + '-' + this.selectedCourse.title;
      }
      // this.addJobForm.controls.client.setValue(this.selectedClient._id)
      this.addJobForm.controls.course.setValue(this.selectedCourse._id)
      this.addJobForm.value['totalDays'] = this.totalDays
      this.addJobForm.value['singleJobDate'] = this.singleJobDate
      // console.log("value of seleected date=========", this.singleJobDate);
      this.error = ''
      console.log(" this.addJobForm.value ", this.addJobForm.value)
      let addformdata = this.addJobForm.value;
      addformdata.instructors = addformdata.instructors
      // delete addformdata.IQAinstructors;
      console.log("updated object data =================>", addformdata);

      if (!this.isNotApplicable && this.totalDays.length && this.singleJobDate.length) {
        console.log('!this.isNotApplicable && this.totalDays && this.singleJobDate', !this.isNotApplicable && this.totalDays && this.singleJobDate)
        console.log('addformdata --------->', addformdata)
        this.saveJob(addformdata)
      } else if (this.isNotApplicable) {
        console.log(this.isNotApplicable)
        console.log('addformdata --------->', addformdata)
        this.saveJob(addformdata)
      } else {
        this.addJobForm.markAllAsTouched()
        this.loading = false;
        this.isDisabled = false;
        console.log("Invalid", this.addJobForm)
        this.isSubmit = true
        this.error = "All fields are required"
        this.isSubmit = true

      }


    }
    else {
      this.addJobForm.markAllAsTouched()
      this.loading = false;
      this.isDisabled = false;
      this.isSubmit = true
      console.log("Invalid", this.addJobForm)
      this.isSubmit = true
      this.error = "All fields are required"
    }

  }

  removeClient(i) {
    console.log("index=", i);
    this.selectedClients.splice(i, 1);


  }

  // Utility functions
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // ALI CALLS
  getClients() {
    this._clientService.getClients().subscribe((clients) => {
      this.clients = clients;
      this.clientsCopy = clients
    });
  }

  getCourses() {
    this._courseService.getCourses().subscribe((courses) => {
      this.courses = courses;
    });
  }

  getInstructors() {
    let getTwoArray = true
    this._staffService.getInstructors(getTwoArray).subscribe((instructors) => {
      console.log("instructors------------> ", instructors);
      if (instructors && instructors.trainers) {
        this.trainersList = instructors.trainers
      }
      if (instructors && instructors.iqa) {
        this.iqaList = instructors.iqa
      }


      if (this.staffDashBoard || this.plannerData && this.plannerData.selectedUser)
        this.dropDownDisable(), this.defaultInstructorSelect()
    });
  }


  defaultInstructorSelect() {
    console.log("CAll this function or not", this.plannerData, this.userIsIQA);

    let id = (this.plannerData && this.plannerData.selectedUser) ? this.plannerData.selectedUser : this.staffDashBoard._id

    if (this.userIsIQA) {
      let index = this.iqaList.findIndex(x => x._id == id);
      console.log("what is the index value of planner add", this.iqaList[index]);
      if (index != -1) {
        let tempInstructor = this.iqaList[index]
        console.log("hello here is the role ", tempInstructor.userId.userRole)

        this.selectedIQA.push(tempInstructor)

        // this.selectedInstructors.push(this.trainersList[index])
      }
    }
    else {
      let index = this.trainersList.findIndex(x => x._id == id);
      console.log("what is the index value of planner add", this.trainersList[index]);
      if (index != -1) {
        let tempInstructor = this.trainersList[index]
        console.log("hello here is the role ", tempInstructor.userId.userRole)
        if (tempInstructor && tempInstructor.userId && tempInstructor.userId.userRole.includes('trainer')) {
          this.selectedInstructors.push(tempInstructor)
        }

        // this.selectedInstructors.push(this.trainersList[index])
      }
    }



    this.addJobForm.controls.instructors.setValue(this.selectedInstructors);
    this.addJobForm.controls.IQAinstructors.setValue(this.selectedIQA);
    console.log("value of pre field data", this.addJobForm.value);
    console.log("what is the selected user value", this.selectedInstructors);

    this.dropDownDisable()


  }


  getIQAinstructordata() {
    // this.IQAinstructors=this.instructors;
    let dataIQA = [];
    let intList = []
    console.log("get IQA instructor====================>", this.instructors)
    this.instructors.forEach((item) => {
      let temp = item.userId.userRole.includes('IQA')

      console.log("temp value", temp);
      if (temp == true) {
        dataIQA.push(item)
      } else {
        intList.push(item)
      }

      //  return item.userId.userRole="IQA"

    });
    // console.log("check IQA Instrucotr data",this.IQAinstructors=dataIQA);
    console.log("only inst list", this.instlist = intList);

  }

  removeClientFormClients(index) {
    console.log(" check here index for remove from selection ", index)

    let clientCopy = this.selectedClients[index].client;
    let locationCopy = this.selectedClients[index].location;
    this.selectedClients.splice(index, 1)

    const foundClientIndex = _.findIndex(this.clients, function (o) { return o._id == clientCopy._id })

    if (foundClientIndex > -1) {
      // console.log(" Client Found ::: ", this.clients[foundClientIndex] ) 
      this.clients[foundClientIndex]['locations'].push(locationCopy)
    }
    else {
      console.log(" Client Not Found Add in clients array ")
      console.log(" Now add location in clients ")
      clientCopy['locations'] = []

      clientCopy['locations'].push(locationCopy)

      this.clients.push(clientCopy)

      this.selectedClient = null
      this.selectedLocation = null


    }



    console.log(" let clientCopy ", clientCopy)
    console.log(" let locationCopy ", locationCopy)

  }

  addClientInClients(event, client) {

    let clientId = client.value.client._id
    const index = _.findIndex(this.clients, function (o) { return o._id == clientId })

    if (index > -1) {
      const index1 = _.findIndex(this.clients[index].locations, function (o) { return o._id == event.value })
      this.clients[index].locations[index1]['added'] = true
    }


  }


  // SAVE JOB API CALL HERE
  saveJob(addformdata) {

    let trainerArray = []
    this.selectedInstructors.map(i => trainerArray.push({ _id: i._id, role: 'trainer' }))
    let iqaArray = []
    this.selectedIQA.map(i => iqaArray.push({ _id: i._id, role: 'IQA' }))
    addformdata.instructors = trainerArray.concat(iqaArray)
    addformdata.instructors = addformdata.instructors.filter(function (element) {
      return element !== undefined;
    });
    delete addformdata.IQAinstructors
    console.log("Here is the job Data ==>", addformdata)
    this._jobService
      .addJob(addformdata)
      .subscribe(data => {
        // this.data = data;
        console.log("data from server after job is added=====>>>>>", data)
        this.loading = false;
        this.isDisabled = false;
        this.handleSnackBar({ msg: "Job added successfully!", button: "Ok" });
        if (this.jobFromScheduler) {
          this.router.navigateByUrl('/scheduler');
        }
        else {
          let param = {
            courseType: data.course.type
          }
          console.log("param =====================", param)
          this.router.navigate(['/job/view/' + data._id], { queryParams: param })
          // this.router.navigateByUrl('/jobs', { state: { view: this.typeOfView } });
        }
      }, err => {
        this.error = err
        this.loading = false;
        this.isDisabled = false;
      })
  }

}
